import { render, staticRenderFns } from "./order-goods-package-count.vue?vue&type=template&id=8827ceda"
import script from "./order-goods-package-count.vue?vue&type=script&lang=js"
export * from "./order-goods-package-count.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports